import { useSetAtom } from "jotai";

import { $createDocumentWorkflow } from "../../internal/document";

/**
 * Hook for creating documents
 */
export const useCreateDocument = () => {
	const createDocumentWorkflow = useSetAtom($createDocumentWorkflow);

	return {
		createDocumentWorkflow,
	};
};
